import { Box, Button, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers } from "../../../../redux/features/foodSlice";
import {
  revertStatus,
  verifyPayment,
} from "../../../../redux/features/trasportationSlice";
import { useSnackbar } from "notistack";
import { Icon } from "@iconify/react";
import VerifyPayment from "./VerifyPayment";

const TransportVerification = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, users } = useSelector((state) => state.food);

  useEffect(() => {
    dispatch(getAllUsers());
  }, []);
  const [gridSize, setGridSize] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);

  const renderStatusCell = (params) => {
    return (
      <Chip
        size="small"
        variant="outlined"
        icon={
          params.row.transport_payment_verification == 0 ? (
            <Icon icon="radix-icons:cross-2" width="15" height="15" />
          ) : (
            <Icon
              icon="material-symbols:verified-outline-rounded"
              width="18"
              height="18"
            />
          )
        }
        color={
          params.row.transport_payment_verification == 0 ? "error" : "success"
        }
        label={
          params.row.transport_payment_verification == 0
            ? "Not Verified"
            : "Verified"
        }
      />
    );
  };

  const renderVerifyButton = (params) => {
    return (
      <Box>
        {params.row.transport_payment_verification == 0 ? (
          <VerifyPayment params={params} />
        ) : (
          <Button
            size="small"
            onClick={() => {
              dispatch(revertStatus(params.row.userID)).then((res) => {
                if (res.payload.status === "success") {
                  enqueueSnackbar(res.payload.message, { variant: "success" });
                  dispatch(getAllUsers());
                } else if (res.payload.status === "failed") {
                  enqueueSnackbar(res.payload.message, { variant: "error" });
                }
              });
            }}
          >
            Revert
          </Button>
        )}
      </Box>
    );
  };
  const TableHead = [
    {
      field: "userID",
      headerName: "SlNo",
      width: 60,
    },
    {
      field: "name",
      headerName: "name",
      width: 250,
    },
    {
      field: "transport_payment_verification",
      headerName: "Status",
      width: 160,
      renderCell: renderStatusCell,
    },
    {
      field: "Verify",
      headerName: "Verify",
      width: 160,
      renderCell: renderVerifyButton,
    },
  ];
  return (
    <GlobalWrapper
      title={"Transport Verification"}
      actions={
        <>
          {selectedIds.length >= 2 ? (
            <VerifyPayment
              bulk={true}
              params={selectedIds}
              setSelectedIds={setSelectedIds}
            />
          ) : null}
        </>
      }
    >
      <Box>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={users}
          columns={TableHead}
          loading={loading}
          getRowId={(row) => row.userID}
          pageSize={gridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
          onSelectionModelChange={(ids) => {
            setSelectedIds(ids);
          }}
          rowSelectionModel={selectedIds}
          checkboxSelection
          disableSelectionOnClick
          isRowSelectable={(params) =>
            params.row.transport_payment_verification == 0
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TransportVerification;
